import { render, staticRenderFns } from "./tingcheList.vue?vue&type=template&id=44787b25&scoped=true&"
import script from "./tingcheList.vue?vue&type=script&lang=js&"
export * from "./tingcheList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44787b25",
  null
  
)

export default component.exports